import { Box } from "@mui/material";
import React from "react";
import DashboardPageTitle from "../../../component/DashboardPageTitle";
const AdminsLists = () => {
    return <Box>
        <DashboardPageTitle title={"Admins List"} />
    </Box>
}

export default AdminsLists